import { Component } from '@angular/core';
import { TeamService } from '../../service/team.service';
import { combineLatest, mergeMap, Observable, of } from 'rxjs';
import { Uitnodiging } from '../../../uitnodiging/model/uitnodiging';
import { UitnodigingenService } from '../../../uitnodiging/service/uitnodinginen.service';
import { ContextService } from '../../../shared/services/context.service';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { teamHeroSources } from '../../component/team-hero-sources';
import { meldingenForTeamPage } from '../../../meldingen/config';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import { TranslateModule } from '@ngx-translate/core';
import { ParkourHeaderActionComponent } from '../../../shared/components/parkour-header-action/parkour-header-action.component';
import {
  ParkourBlockPlaceholderComponent,
  ParkourButtonComponent,
  ParkourDividerComponent,
  ParkourHeroComponent,
  ParkourPageImageComponent,
} from '@parkour/ui';
import { AsyncPipe } from '@angular/common';
import { TeammemberUitnodigingComponent } from '../../component/teammember-uitnodiging/teammember-uitnodiging.component';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import { TeammemberActionComponent } from '../../component/teammember-action/teammember-action.component';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import { ParkourDataPage } from '../../../shared/parkour-data-page';
import { MeldingenToMarkAsRead } from '../../../shared/marks-meldingen-as-read';
import { PageSectionDirective } from '../../../shared/directives/page-section.directive';

export type TeamJongerePageData = {
  teamleden: Array<TeamlidProfiel>;
  uitnodigingen: Array<Uitnodiging>;
};

@Component({
  standalone: true,
  templateUrl: './team-jongere.page.html',
  imports: [
    ParkourBackButtonDirective,
    TranslateModule,
    ParkourHeaderActionComponent,
    ParkourHeroComponent,
    ParkourPageImageComponent,
    ParkourDividerComponent,
    AsyncPipe,
    ParkourButtonComponent,
    ParkourBlockPlaceholderComponent,
    TeammemberUitnodigingComponent,
    PageLayoutComponent,
    TeammemberActionComponent,
    IonRefresher,
    IonRefresherContent,
    IonBackButton,
    ParkourRefreshDirective,
    IonContent,
    IonButtons,
    IonTitle,
    IonToolbar,
    IonHeader,
    PageSectionDirective,
  ],
})
export class TeamJongerePage extends ParkourDataPage<TeamJongerePageData> {
  protected readonly teamHeroSources = teamHeroSources;

  constructor(
    private readonly teamService: TeamService,
    private readonly contextService: ContextService,
    private readonly uitnodigingenService: UitnodigingenService,
  ) {
    super();
  }

  override retrieveMainData(): Observable<TeamJongerePageData> {
    return combineLatest({
      teamleden: this.teamService.getMyTeamleden(),
      uitnodigingen: this.contextService.contextIdOfJongere$().pipe(
        mergeMap((contextId) => {
          return this.uitnodigingenService.getUitnodigingenVanJongere(contextId);
        }),
      ),
    });
  }

  getMeldingenToMarkAsRead() {
    return of(new MeldingenToMarkAsRead(meldingenForTeamPage.specificMeldingen));
  }
}
